// BrightFilter.jsx
import React from 'react';
import { FILTER_PRESETS } from 'constants/filters';
import FilterPresetButton from './FilterPresetButton';

export default function BrightFilter() {
  return (
    <FilterPresetButton
      presetKey={FILTER_PRESETS.BRIGHT}
      label="Bright"
      image="bright"
      thumbnailClassName="bg-gradient-to-br from-yellow-200 via-amber-100 to-white"
      showRecommended
    />
  );
}
